var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultImgNews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A936F",
    d: "M0 0h112v112H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.333 41.586 9.31 9.31A3.25 3.25 0 0 0 38.24 46.3L11.134 19.195a2.75 2.75 0 1 1 3.889-3.89l22.392 22.392a3.25 3.25 0 0 0 4.596-4.596L31.522 22.612a3.25 3.25 0 0 1 4.596-4.596l12.357 12.357c11.922-3.643 25.413-.75 34.843 8.68C95.226 50.96 96.71 69.344 87.77 82.866l9.277 9.277a3.25 3.25 0 0 1-4.596 4.597l-11.55-11.55a3.25 3.25 0 1 0-4.595 4.596l4.478 4.479a3.25 3.25 0 1 1-4.596 4.596l-3.343-3.342c-12.789 5.684-28.301 3.282-38.79-7.206-7.316-7.317-10.697-17.079-10.143-26.656a2.787 2.787 0 0 1-.168-.155l-7.071-7.071a2.75 2.75 0 1 1 3.889-3.89l4.596 4.597a1.25 1.25 0 0 0 1.768-1.768l-7.189-7.189a3.25 3.25 0 1 1 4.596-4.596ZM12.548 29.801l4.478 4.478a3.25 3.25 0 0 1-4.596 4.597l-4.478-4.479a3.25 3.25 0 1 1 4.596-4.596Zm90.285 15.616a2.583 2.583 0 1 1 0-5.167 2.583 2.583 0 0 1 0 5.167Zm0-1.5a1.084 1.084 0 1 0 0-2.167 1.084 1.084 0 0 0 0 2.167Zm-75.916-26.75a2.583 2.583 0 1 1 0-5.167 2.583 2.583 0 0 1 0 5.167Zm0-1.5a1.084 1.084 0 1 0 0-2.167 1.084 1.084 0 0 0 0 2.167Zm-8.334 55a1.584 1.584 0 1 1 0-3.167 1.584 1.584 0 0 1 0 3.167Zm0-.92a.664.664 0 1 0 0-1.328.664.664 0 0 0 0 1.328ZM19.833 88h1a.5.5 0 1 1 0 1h-1v1a.5.5 0 1 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0v1Zm47.521-69.354h1.209a.604.604 0 0 1 0 1.208h-1.209v1.213a.6.6 0 0 1-.6.6h-.008a.6.6 0 0 1-.6-.6v-1.213h-1.209a.604.604 0 0 1 0-1.208h1.209v-1.213a.6.6 0 0 1 .6-.6h.008a.6.6 0 0 1 .6.6v1.213Zm31.084 40.25h.708a.354.354 0 0 1 0 .708h-.709v.713a.35.35 0 0 1-.35.35h-.008a.35.35 0 0 1-.35-.35v-.713h-.708a.354.354 0 0 1 0-.708h.708v-.713a.35.35 0 0 1 .35-.35h.009a.35.35 0 0 1 .35.35v.713Z",
    fill: "#FFF",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27 34)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 19h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V21a2 2 0 0 1 2-2Zm1 2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1H9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 0h45.167a4 4 0 0 1 4 4v4.35H58V40a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4Zm1 3a2 2 0 0 0-2 2v34a2 2 0 0 0 2 2h48c-1.603-1.853-2.404-3.734-2.404-5.645V5a2 2 0 0 0-2-2H5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#FFF",
    x: 5.5,
    y: 11.5,
    width: 41,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#FFF",
    x: 27.5,
    y: 19.5,
    width: 19,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#FFF",
    x: 27.5,
    y: 27.5,
    width: 9,
    height: 1,
    rx: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImgNews);
export default __webpack_public_path__ + "static/media/default-img-news.a078eea15beba761a7fe52397d2a88d0.svg";
export { ForwardRef as ReactComponent };